// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"bc59cd92","239":"4f9861ba","278":"d5a2d7cc","279":"0922f427","340":"d61197c4","453":"1d41151e","455":"52f4525e","473":"eb06ca39","508":"495c2d72","537":"212bb861","719":"b0c38e85","977":"1dad3c7e"}[chunkId] + ".chunk.js";
};